"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _params = require("hub-http/helpers/params");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var propTypes = {
  objectType: _propTypes.default.string.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  subject: _propTypes.default.object,
  linkedInParams: _propTypes.default.object,
  height: _propTypes.default.number.isRequired,
  modules: _propTypes.default.arrayOf(_propTypes.default.string)
};
var BASE_URL = 'https://www.linkedin.com/sales/widget/';
var API_KEY = '77scjxoy2lseuh';

var LinkedInSalesNavigatorIframe =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkedInSalesNavigatorIframe, _Component);

  function LinkedInSalesNavigatorIframe() {
    (0, _classCallCheck2.default)(this, LinkedInSalesNavigatorIframe);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkedInSalesNavigatorIframe).apply(this, arguments));
  }

  (0, _createClass2.default)(LinkedInSalesNavigatorIframe, [{
    key: "getContactParams",
    value: function getContactParams() {
      var subject = this.props.subject;
      var params = {};

      if ((0, _ImmutableModel.getProperty)(subject, 'firstname')) {
        params.firstName = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'firstname'));
      }

      if ((0, _ImmutableModel.getProperty)(subject, 'lastname')) {
        params.lastName = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'lastname'));
      }

      if ((0, _ImmutableModel.getProperty)(subject, 'email')) {
        params.email = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'email'));
      }

      if ((0, _ImmutableModel.getProperty)(subject, 'company')) {
        params.companyName = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'company'));
      }

      if ((0, _ImmutableModel.getProperty)(subject, 'jobtitle')) {
        params.title = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'jobtitle'));
      }

      return params;
    }
  }, {
    key: "getCompanyParams",
    value: function getCompanyParams() {
      var subject = this.props.subject;
      var params = {
        profile: 'account'
      };

      if ((0, _ImmutableModel.getProperty)(subject, 'name')) {
        params.name = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'name'));
      }

      if ((0, _ImmutableModel.getProperty)(subject, 'domain')) {
        params.website = encodeURIComponent((0, _ImmutableModel.getProperty)(subject, 'domain'));
      }

      return params;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          subjectId = _this$props.subjectId,
          modules = _this$props.modules,
          linkedInParams = _this$props.linkedInParams;
      var matchType = objectType === _ObjectTypes.CONTACT ? 'profile-matching' : 'company-matching';
      var extraParams;

      if (linkedInParams) {
        extraParams = linkedInParams;
      } else {
        extraParams = objectType === _ObjectTypes.CONTACT ? this.getContactParams() : this.getCompanyParams();
      }

      var params = (0, _extends2.default)({
        apiKey: API_KEY,
        crmRecordId: subjectId,
        crmOrgId: 'HUBSPOT_CRM',
        crmSourceType: 'HUBSPOT',
        version: '2.0.0'
      }, extraParams);

      if (modules) {
        params.modules = modules.join(',');
      }

      return "" + BASE_URL + matchType + "?" + (0, _params.stringify)(params);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var height = this.props.height;
      return _react.default.createElement("iframe", {
        className: "sales-navigator-iframe",
        ref: function ref(_ref) {
          _this.iframe = _ref;
        },
        src: this.getUrl(),
        style: {
          border: 'none',
          width: '100%'
        },
        height: height,
        type: "text/html"
      });
    }
  }]);
  return LinkedInSalesNavigatorIframe;
}(_react.Component);

LinkedInSalesNavigatorIframe.propTypes = propTypes;
var _default = LinkedInSalesNavigatorIframe;
exports.default = _default;
module.exports = exports.default;